<template>
  <div class="flex flex-row justify-between items-center gap-2 font-rubik">
    <button
      class="close-menu-button border rounded-full flex items-center justify-center"
      @click="toggleMenu()"
    >
      <img
        class=""
        src="@/images/header/close.svg"
        alt="Close menu"
      />
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: true
    }
  },
  methods: {
    toggleMenu() {      
      this.isActive = !this.isActive 
      this.$emit('update:activeMobileMenu', this.isActive)
    }
  }
}
</script>

<style scoped>
  .close-menu-button {
    width: 40px;
    height: 40px;
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: -0.04em;
    background-color: #3565FC;
    border: 1px solid #3565FC;
  }
</style>